// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus";
import {
  generateChartCanvas,
  canvasToBlob,
  uploadChartImage,
} from "../helpers/chart_helpers";

export default class extends Controller {
  static values = {
    markResultId: String,
    accountName: String,
    taskName: String,
    taskId: String,
    subTaskId: String,
    userSubTaskId: String,
    markItemId: String,
    taskDuration: String,
    duration: String,
  };

  connect() {
    console.log("Mark Result Chart Controller connected", {
      markResultId: this.markResultIdValue,
      autoGenerate: this.element.dataset.autoGenerate,
    });

    // 如果设置了自动生成标志，连接后立即生成
    if (this.element.dataset.autoGenerate === "true") {
      console.log("Auto-generating chart...");
      this.generate();
    }
  }

  async generate() {
    try {
      console.log("Starting chart generation...");

      // 使用共享函数生成 canvas
      const canvas = generateChartCanvas({
        taskName: this.taskNameValue,
        taskId: this.taskIdValue,
        subTaskId: this.subTaskIdValue,
        userSubTaskId: this.userSubTaskIdValue,
        markItemId: this.markItemIdValue,
      });

      console.log("Converting canvas to blob...");
      const blob = await canvasToBlob(canvas);
      console.log("Blob created, size:", blob.size);

      console.log("Starting upload...");
      const response = await uploadChartImage(this.markResultIdValue, blob);
      const data = await response.json();
      console.log("任务图片生成并上传成功", data);

      // 触发页面刷新以显示新图片
      window.location.reload();
    } catch (error) {
      console.error("图片生成或上传失败:", error);
    }
  }
}
